<template>
  <LayoutFullWidth :class="`dbc-block-background-${data.backgroundColor}`">
    <div
      class="dbc-gl-section flex flex-wrap items-center gap-[1rem] p-[2rem] px-[3rem] max-tablet:flex-col max-tablet:items-start max-mobile:p-[1.75rem] max-mobile:px-[1.5rem]"
    >
      <strong>{{ $t('dbc-quick-access') }}</strong>
      <UtilityButton
        v-for="button in content.buttons"
        :button="button"
        class="[&>.dbc-gc-btn]:min-w-[200px] max-tablet:[&>.dbc-gc-btn]:min-w-full max-tablet:min-w-full"
      />
    </div>
  </LayoutFullWidth>
</template>
<script setup lang="ts">
const props = defineProps<{
  content: ButtonBanner
}>()

const data = normalizeButtonBanner(props.content)
</script>
